import { inject, Injectable, OnDestroy } from '@angular/core';
import { bufferTime, catchError, EMPTY, filter, Subject, switchMap, withLatestFrom } from 'rxjs';
import { ApiService } from '../service/api.service';
import { MarketId } from '../model/common';
import { AccountService } from '../service/account.service';

export interface RestRequestLogRow {
  time: number
  market: MarketId
  type: 'rest'
  url: string
  params: any
  httpCode: number
  apiCode: number | string
  apiMessage: string
  apiDetails?: any
}

export interface WsRequestLogRow {
  time: number
  market: MarketId
  type: 'ws'
  wsKey: string
  side: 'client' | 'server'
  event: 'open' | 'close' | 'reconnect' | 'auth' | 'request' | 'response' | 'message' | 'error'
  payload: any
  apiCode?: number | string
  apiMessage?: string
  apiDetails?: any
}

@Injectable({
  providedIn: 'root'
})
export class MarketLoggerService implements OnDestroy {

  private api = inject(ApiService)
  private account = inject(AccountService)

  private writeSubject = new Subject<any>()
  private isBlocked = false

  constructor() {
    this.writeSubject.pipe(
      bufferTime(10_000),
      filter(rows => rows.length > 0),
      withLatestFrom(this.account.profile$),
      switchMap(([rows, profile]) => {
        if (this.isBlocked) {
          return EMPTY
        }
        return this.api.post('/weblog/market-log', {rows, accId: profile?.id ?? 0})
      }),
      catchError(() => {
        this.isBlocked = true
        setTimeout(() => this.isBlocked = false, 60_000)
        return EMPTY
      })
    ).subscribe()
  }

  ngOnDestroy(): void {
    this.writeSubject.complete()
  }

  log(row: RestRequestLogRow | WsRequestLogRow) {
    this.writeSubject.next(row)
  }

}
